import { Button, CircularProgress } from '@mui/material'
import Download from '@mui/icons-material/Download'

export default function ImportPatientHistoryButton({
  onImport,
  isImporting,
  disabled = false,
  label = 'Import Patient History from Screening Report',
  importingLabel = 'Importing...',
}) {
  if (disabled) return null

  return (
    <Button
      size="small"
      variant="contained"
      onClick={onImport}
      disabled={isImporting}
      endIcon={<Download />}
      disableElevation
    >
      {isImporting ? (
        <>
          <CircularProgress size={12} sx={{ marginRight: '4px' }} />
          {importingLabel}
        </>
      ) : (
        label
      )}
    </Button>
  )
}
